var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "lds-message",
    width: "100px",
    height: "50px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "rgba(0, 0, 0, 0) none repeat scroll 0% 0%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#a100ff"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.375s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#282c34"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.25s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#a100ff"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "-0.125s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#282c34"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    begin: "0s",
    calcMode: "spline",
    keySplines: "0.3 0 0.7 1;0.3 0 0.7 1",
    values: "0;1;0",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.e4920315.svg";
export { ForwardRef as ReactComponent };